// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import BusTicket from '../_raw/ui/icon_bus_ticket.svg';
import withIconProps from '../withIconProps';

export default withIconProps(BusTicket);
